export function isAccOn(state) {
  if (state & 0x01 === 0x01) {
    return true
  } else {
    return false
  }
}

export function explainDirection(direction) {
  if (direction > 22 && direction <= 67) {
    return '东北'
  } else if (direction > 67 && direction <= 112) {
    return '东'
  } else if (direction > 112 && direction <= 157) {
    return '东南'
  } else if (direction > 157 && direction <= 202) {
    return '南'
  } else if (direction > 202 && direction <= 247) {
    return '西南'
  } else if (direction > 247 && direction <= 292) {
    return '西'
  } else if (direction > 292 && direction <= 337) {
    return '西北'
  } else if ((direction <= 22 && direction >= 0) || (direction > 337 && direction <= 360)) {
    return '北'
  }
}

export function explainState(state) {
  let result = []
  if (state & 0x01 === 0x01) {
    result.push('ACC开')
  } else {
    result.push('ACC关')
  }
  if ((state >>> 1) & 0x01 === 0x01) {
    result.push('定位')
  } else {
    result.push('未定位')
  }
  if ((state >>> 2) & 0x01 === 0x01) {
    result.push('南纬')
  } else {
    result.push('北纬')
  }
  if ((state >>> 3) & 0x01 === 0x01) {
    result.push('西经')
  } else {
    result.push('东经')
  }
  if ((state >>> 4) & 0x01 === 0x01) {
    result.push('停运状态')
  } else {
    result.push('运营状态')
  }
  // if ((state >>> 5) & 0x01 === 0x01) {
  //   result += '经纬度已经保密插件加密,'
  // } else {
  //   result += '经纬度未经保密插件加密,'
  // }
  if ((state >>> 10) & 0x01 === 0x01) {
    result.push('车辆油路断开')
  } else {
    result.push('车辆油路正常')
  }
  if ((state >>> 11) & 0x01 === 0x01) {
    result.push('车辆电路断开')
  } else {
    result.push('车辆电路正常')
  }
  // if ((state >>> 12) & 0x01 === 0x01) {
  //   result += '车门加锁,'
  // } else {
  //   result += '车门解锁,'
  // }
  // if ((state >>> 13) & 0x01 === 0x01) {
  //   result += '门1开(前门),'
  // } else {
  //   result += '门1关(前门),'
  // }
  // if ((state >>> 14) & 0x01 === 0x01) {
  //   result += '门2开(中门),'
  // } else {
  //   result += '门2关(中门),'
  // }
  // if ((state >>> 15) & 0x01 === 0x01) {
  //   result += '门3开(后门),'
  // } else {
  //   result += '门3关(后门),'
  // }
  // if ((state >>> 16) & 0x01 === 0x01) {
  //   result += '门4开(驾驶席门),'
  // } else {
  //   result += '门4关(驾驶席门),'
  // }
  // if ((state >>> 17) & 0x01 === 0x01) {
  //   result += '门5开(自定义),'
  // } else {
  //   result += '门5关(自定义),'
  // }
  if ((state >>> 18) & 0x01 === 0x01) {
    result.push('使用GPS卫星进行定位')
  } else {
    // result += '未使用GPS卫星进行定位,'
  }
  if ((state >>> 19) & 0x01 === 0x01) {
    result.push('使用北斗卫星进行定位')
  } else {
    // result += '未使用北斗卫星进行定位,'
  }
  if ((state >>> 20) & 0x01 === 0x01) {
    result.push('使用GLONASS卫星进行定位')
  } else {
    // result += '未使用GLONASS卫星进行定位,'
  }
  if ((state >>> 21) & 0x01 === 0x01) {
    result.push('使用Galileo卫星进行定位')
  } else {
    // result += '未使用Galileo卫星进行定位,'
  }
  return result
}


export function explainAlarmSign(state) {
  let result = ''
  if (state & 0x01 === 0x01) {
    result += '紧急报警,'
  }
  if ((state >>> 1) & 0x01 === 0x01) {
    result += '超速报警,'
  }
  if ((state >>> 2) & 0x01 === 0x01) {
    result += '疲劳驾驶,'
  }
  if ((state >>> 3) & 0x01 === 0x01) {
    result += '危险预警,'
  }
  if ((state >>> 4) & 0x01 === 0x01) {
    result += 'GNSS模块发生故障,'
  }
  if ((state >>> 5) & 0x01 === 0x01) {
    result += 'GNSS天线未接或被剪断,'
  }
  if ((state >>> 6) & 0x01 === 0x01) {
    result += 'GNSS天线短路,'
  }
  if ((state >>> 7) & 0x01 === 0x01) {
    result += '终端主电源欠压,'
  }
  if ((state >>> 8) & 0x01 === 0x01) {
    result += '终端主电源掉电,'
  }
  if ((state >>> 9) & 0x01 === 0x01) {
    result += '终端LCD或显示器故障,'
  }
  if ((state >>> 10) & 0x01 === 0x01) {
    result += 'TTS模块故障,'
  }
  if ((state >>> 11) & 0x01 === 0x01) {
    result += '摄像头故障,'
  }
  if ((state >>> 12) & 0x01 === 0x01) {
    result += '道路运输证IC卡模块故障,'
  }
  if ((state >>> 13) & 0x01 === 0x01) {
    result += '超速预警,'
  }
  if ((state >>> 14) & 0x01 === 0x01) {
    result += '疲劳驾驶预警,'
  }
  if ((state >>> 18) & 0x01 === 0x01) {
    result += '当天累计驾驶超时,'
  }
  if ((state >>> 19) & 0x01 === 0x01) {
    result += '超时停车,'
  }
  if ((state >>> 20) & 0x01 === 0x01) {
    result += '进出区域,'
  }
  if ((state >>> 21) & 0x01 === 0x01) {
    result += '进出路线,'
  }
  if ((state >>> 22) & 0x01 === 0x01) {
    result += '路段行驶时间不足/过长,'
  }
  if ((state >>> 23) & 0x01 === 0x01) {
    result += '路线偏离报警,'
  }
  if ((state >>> 24) & 0x01 === 0x01) {
    result += '车辆VSS故障,'
  }
  if ((state >>> 25) & 0x01 === 0x01) {
    result += '车辆油量异常,'
  }
  if ((state >>> 26) & 0x01 === 0x01) {
    result += '车辆被盗(通过车辆防盗器),'
  }
  if ((state >>> 27) & 0x01 === 0x01) {
    result += '车辆非法点火,'
  }
  if ((state >>> 28) & 0x01 === 0x01) {
    result += '车辆非法位移,'
  }
  if ((state >>> 29) & 0x01 === 0x01) {
    result += '碰撞预警,'
  }
  if ((state >>> 30) & 0x01 === 0x01) {
    result += '侧翻预警,'
  }
  if ((state >>> 31) & 0x01 === 0x01) {
    result += '非法开门报警,'
  }
  return result
}
